import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {retry, switchMap} from 'rxjs/operators';
import {BaseService} from './base.service';

@Injectable({
    providedIn: 'root'
})
export abstract class ApiService extends BaseService {
    protected constructor(
        protected httpClient: HttpClient,
    ) {
        super();
    }

    public list(route: string, pageNumber: number = 1, pageSize: number = 50): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/${route}?page[number]=${pageNumber}&page[size]=${pageSize}`)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }


    public queryList(route: string, pageNumber: number = 1, pageSize: number = 50): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/${route}&page[number]=${pageNumber}&page[size]=${pageSize}`)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public get(route: string, params?, responseType?): Observable<any> {
        return this.httpClient
            .get<any>(`${this.apiUrl}/${route}`, {
                params: params,
                responseType: responseType
            })
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public post(route: string, data: any): Observable<any> {
        return this.httpClient
            .post<any>(`${this.apiUrl}/${route}`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public put(route: string, data: any): Observable<any> {
        return this.httpClient
            .put<any>(`${this.apiUrl}/${route}?_method=PUT`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public create(route: string, data: any): Observable<any> {
        return this.httpClient
            .post<any>(`${this.apiUrl}/${route}`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public update(route: string, id: string | number, data: any, usePut: boolean = false): Observable<any> {
        return this.httpClient
            .put<any>(`${this.apiUrl}/${route}/${id}${usePut ? '?_method=PUT' : ''}`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public updateViaPost(route: string, id: string | number, data: any, usePut: boolean = false): Observable<any> {
        return this.httpClient
            .post<any>(`${this.apiUrl}/${route}/${id}${usePut ? '?_method=PUT' : ''}`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public updateSettings(route: string, data: any, usePut: boolean = false): Observable<any> {
        return this.httpClient
            .put<any>(`${this.apiUrl}/${route}`, data)
            .pipe(switchMap((response: any) => {
                return of(response);
            }));
    }

    public delete(route: string, id: string | number): Observable<void> {
        return this.httpClient.delete<void>(`${this.apiUrl}/${route}/${id}`);
    }
}
